<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4 class="homeReport">Información de vista</h4>
    <hr>

    <div class="form-group row">

        <div class="textOnInput col-4 col-md-4">
            <label class="form-label" for="inputText">Sectores</label>
            <select class="form-select form-input" formControlName="idsector"
                [class.is-invalid]="campoNoValido('idsector')">
                <option selected [ngValue]="null">sector...</option>
                <ng-container *ngFor="let s of sectores; let i = index">
                    <option [ngValue]="s.id" [disabled]="sectorSeleccionado(s.id)">{{ s.longname }}</option>
                </ng-container>
            </select>
            <small class="text-danger" *ngIf="campoNoValido('idsector')">Este campo es requerido</small>
        </div>

        <!-- Sección de selección de tipo -->
<div class="textOnInput col-12">
    <label class="form-label">Reporte sectorial</label>
    <div class="label-container">
        <div class="row">
            <div class="col-md-12 mb-3">
                <!-- Alerta informativa para edición -->
                <div class="alert alert-warning mt-2" *ngIf="edit && originalUploadType === 'file' && uploadType === 'url'">
                  <small>
                    <i class="fa fa-exclamation-triangle me-2"></i>
                    <strong>Atención:</strong> Para cambiar a URL primero debes eliminar el documento PDF actual.
                    <ul class="mt-1 mb-0">
                      <li>Haz clic en la <strong>X</strong> junto al nombre del PDF para eliminarlo</li>
                      <li>Luego podrás ingresar y guardar la nueva URL</li>
                    </ul>
                  </small>
                </div>

                <div class="alert alert-info mt-2" *ngIf="edit && !(originalUploadType === 'file' && uploadType === 'url')">
            <small>
              <i class="fa fa-info-circle me-2"></i>
              <strong>Estás editando:</strong> {{ originalUploadType === 'file' ? 'Documento PDF (' + filenamePDF + ')' : 'Enlace URL' }}
            </small>
          </div>

            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="uploadType" id="uploadTypeFile" value="file"
                [(ngModel)]="uploadType" [ngModelOptions]="{ standalone: true }"
                [disabled]="edit && originalUploadType === 'url' && uploadType === 'file'" />
              <label class="form-check-label" for="uploadTypeFile">
                Subir documento PDF
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="uploadType" id="uploadTypeUrl" value="url"
                [(ngModel)]="uploadType" [ngModelOptions]="{ standalone: true }"
                [disabled]="edit && originalUploadType === 'file' && uploadType === 'url'" />
              <label class="form-check-label" for="uploadTypeUrl">
                Usar URL externa
              </label>
            </div>
            <small *ngIf="edit" class="text-muted">
              (Registro actual: {{ originalUploadType === 'file' ? 'PDF' : 'URL' }})
            </small>
            </div>

            <!-- Sección para PDF -->
            <div class="col-md-12" *ngIf="uploadType === 'file'">
                <div class="input-group">
                    <div class="input-group-append">
                        <button class="btn btn-outline-primary custom-rounded-button"
                            type="button"
                            (click)="fileInputReporteSectorial.click()">
                            <i class="fas fa-upload me-2"></i>Seleccionar PDF
                        </button>
                    </div>
                    <input type="text" disabled class="form-control"
                        placeholder="Ningún archivo seleccionado"
                        [value]="filenamePDF">
                </div>
                <input #fileInputReporteSectorial type="file"
                    style="display: none"
                    accept=".pdf"
                    (change)="onPdfChange($event)">

                <!-- Controles PDF -->
                <div class="pdf-item mt-2" *ngIf="showPdfControls && originalUploadType === 'file'">
                  <span class="pdf-name">
                    <i class="fa fa-file-pdf-o me-2"></i>{{ filenamePDF }}
                    <small class="text-muted">(PDF actual)</small>
                  </span>
                  <button class="pdf-delete-button" (click)="removePdf()" type="button"
                    [disabled]="uploadType === 'url'">
                    x
                  </button>
                </div>
            </div>

            <!-- Sección para URL -->
            <div class="col-md-12 mt-3" *ngIf="uploadType === 'url'">
                <input type="url" class="form-control"
                    formControlName="url"
                    placeholder="https://ejemplo.com/reporte-sectorial.pdf"
                    [class.is-invalid]="form.get('url').invalid && form.get('url').touched">

                <div class="invalid-feedback" *ngIf="form.get('url').errors?.pattern">
                    La URL debe comenzar con https://
                </div>
                <small class="text-muted">
                    Ejemplo válido: https://tu-dominio.com/informe-2023.pdf
                </small>
            </div>
        </div>
    </div>
</div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Visible/oculto</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>


    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="cancel()">Cancelar</button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">
                        <span *ngIf="isLoading" [ngClass]="{ 'spinner-border spinner-border-sm': isLoading }"
                            role="status" aria-hidden="true"></span>
                        <span *ngIf="isLoading"> Guardando...</span>
                        <span *ngIf="!isLoading"> Guardar</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

</form>


<!-- Tabla para mostrar columnas de formulario -->
<hr>
<div style="padding: 15px; margin-top: 40px;">
    <div class="row">
        <div class="text-start">
            <h6>Lista de reportes</h6>
        </div>
    </div>
    <div class="row">
        <div class="table-responsive">
            <table class="table">
                <thead class="thead-detail text-center table-success">
                    <tr>
                        <th scope="col">N°</th>
                        <th scope="col">Sector</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Nombre Doc</th>
                        <th scope="col">Url Doc</th>
                        <th scope="col">Estado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="tbody-detail" *ngFor="let r of reports; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ r.longname }}</td>
                        <td>
                          <span *ngIf="r.url?.startsWith('http')" class="badge bg-info">URL</span>
                          <span *ngIf="!r.url?.startsWith('http')" class="badge bg-primary">PDF</span>
                        </td>
                        <td>{{ r.doc_name }}</td>
                        <td>{{ r.url }}</td>
                        <td class="text-center">
                            <div class="label-active text-center" *ngIf="r.status">ACTIVO</div>
                            <div class="label-inactive text-center" *ngIf="!r.status">INACTIVO</div>
                        </td>
                        <td class="text-center">
                            <a class="a-icon" (click)="editReport(r)"><i class="fa fa-pencil i-icon"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
